import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

const ADVISOR_IMAGE =
  "https://customer-assets.emergentagent.com/job_valuta-genio-landing/artifacts/h40hh0b5_PROPERTY%20ADVISOR%20al%20desk%2002%20comp.png";

function getRefFromCookie() {
  if (typeof document === "undefined") return "";
  const m = document.cookie.match(/(?:^|; )vg_ref=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
}

function withRef(path) {
  const ref = getRefFromCookie();
  return ref ? `${path}${path.includes("?") ? "&" : "?"}ref=${encodeURIComponent(ref)}` : path;
}

export default function PropertyAdvisor() {
  return (
    <section
      id="property-advisor"
      data-testid="property-advisor-section"
      className="bg-white py-20 md:py-28"
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Image */}
          <Reveal className="order-1">
            <div className="relative rounded-2xl overflow-hidden vg-card-shadow aspect-[4/5] md:aspect-[5/6]">
              <img
                src={ADVISOR_IMAGE}
                alt="Property Advisor di ValutaGenio alla scrivania mentre riordina il quadro con un proprietario"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/15 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 bg-white/95 backdrop-blur rounded-xl px-5 py-4 flex items-center gap-4 vg-card-shadow">
                <div className="w-10 h-10 rounded-full bg-[#B40101]/10 flex items-center justify-center">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B40101" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 6 9 17l-5-5"/>
                  </svg>
                </div>
                <div>
                  <div className="text-[#0A0A0A] font-semibold text-sm">Professionisti selezionati</div>
                  <div className="text-[#0A0A0A]/60 text-xs">Il confronto parte solo da una tua richiesta</div>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Text */}
          <Reveal delay={120} className="order-2">
            <span className="inline-block text-xs uppercase tracking-[0.2em] font-semibold text-[#B40101] mb-4">
              Property Advisor
            </span>
            <h2 className="font-display font-bold text-[#0A0A0A] text-4xl md:text-5xl tracking-tight leading-[1.1]">
              Quando il quadro è chiaro, il confronto vale di più
            </h2>

            <p className="mt-6 text-[#0A0A0A]/80 text-[17px] md:text-[18px] leading-relaxed">
              Qual è il dato da tenere d&apos;occhio? Quale problema affrontare subito? Quando lo desideri, puoi chiedere gratuitamente un confronto con il Property Advisor assegnato. Vedrà le analisi completate e partirà dal tuo caso, senza costringerti a raccontare tutto da capo.
            </p>

            <div className="my-7 p-5 rounded-xl bg-[#F5F5F5] border-l-4 border-[#B40101]">
              <p className="text-[#0A0A0A] text-[16px] md:text-[17px] leading-relaxed">
                Hai completato il percorso e messo a fuoco obiettivo, valore e preparazione. Il tuo Property Advisor può ora trasformare il quadro in <span className="text-[#B40101] font-semibold">tre indicazioni concrete: priorità, rischi e prossimo passo</span>.
              </p>
            </div>

            <p className="text-[#0A0A0A]/70 text-[15px] leading-relaxed">
              La richiesta di contatto è una tua scelta. Il confronto non comporta incarichi o impegni commerciali.
            </p>

            <a
              data-testid="property-advisor-cta"
              href={"/app"}
              className="mt-8 inline-flex items-center gap-2 bg-[#B40101] hover:bg-[#8E0101] text-white font-semibold text-base px-6 py-3.5 rounded-xl transition-all duration-200 hover:-translate-y-0.5 shadow-[0_10px_30px_rgba(180,1,1,0.30)]"
            >
              Scegli il tuo punto di partenza <ArrowRight className="w-5 h-5" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
